module.exports = __webpack_public_path__ + "static/media/cloud-download.8b5d19b8.svg";